var _helper = {
	makeArray: function(value) {
		var arr = value.split(',');
		for (var i = 0; i < arr.length; i++) {
			arr[i] = arr[i].trim();
		}
		return arr;
	},
	transform: function(transform) {
		return {
			'-webkit-transform': transform,
			'-moz-transform': transform,
			'-ms-transform': transform,
			'transform': transform
		};
	},
	transition: function(transition) {
		return {
			'-webkit-transition': transition,
			'-moz-transition': transition,
			'-ms-transition': transition,
			'transition': transition
		}
	},
	shuffle: function(a) {
		var j, x, i;
		for (i = a.length; i; i -= 1) {
			j = Math.floor(Math.random() * i);
			x = a[i - 1];
			a[i - 1] = a[j];
			a[j] = x;
		}
	},
	resize : {
		columnsHeight: function($columns, rows) {
			/*
			make everyting in the same row the same hight
			the scripts recognizes self the rows
			Usage:
			_resize.columnsHeight('ul.columns li');
			*/
			if (typeof $columns != 'object') {
				$columns = $($columns);
			}
			$columns.css({'height' : 'auto'}).removeClass('resized');
			var itemsInRow = rows;
			column = 0;
			rowHeight = 0,
			first = true,
			total = $columns.length;
			if (rows == false || typeof itemsInRow == 'undefined') {
				itemsInRow = Math.floor($columns.parent().width() / $columns.first().outerWidth(true));
			}
			$columns.each(function(i) {
				column++;
				var itemHeight = $(this).height();
				if (rowHeight < itemHeight) {
					rowHeight = itemHeight;
				}
				if (column >= itemsInRow || i == total - 1) {
					column = 0;
					$(this).prevAll(':not(.resized)').addClass('resized').css({'height' : rowHeight});
					$(this).addClass('resized').css({'height' : rowHeight});
					rowHeight = 0;
				}
			});
		},
		video: function($video, $proportion) {
			/*
			scale video in porportion
			Usage:
			_resize.video($('.video'), [16,9]);
			*/
			if (typeof $video != 'object') {
				$video = $($video);
			}
			$video.css({'height' : 'auto', 'width' : '100%'});
			var width = $video.width(),
			height = Math.round(width / $proportion[0] * $proportion[1]);
			$video.css({'height' : height});
		}
	}
}
